import { render, staticRenderFns } from "./webWxlogin.vue?vue&type=template&id=7f51ec35&"
import script from "./webWxlogin.vue?vue&type=script&lang=js&"
export * from "./webWxlogin.vue?vue&type=script&lang=js&"
import style0 from "./webWxlogin.vue?vue&type=style&index=0&id=7f51ec35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports